const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('contact form') // eslint-disable-line

function ErrorLabel({ error, htmlFor }) {
    if (! error) return null

    return (
        <label className="error glyph-attention" htmlFor={htmlFor}>{error}</label>
    )
}
ErrorLabel.propTypes = {
    error: PropTypes.string,
    htmlFor: PropTypes.string,
}

module.exports = ErrorLabel
